export default __webpack_public_path__ + "static/media/gotham-medium.0ad7d622.woff2";